module.exports = __webpack_public_path__ + "33d08b61c7c3140f7dbb8d3651b3c8eb.png";